import { InfoBold } from "@/assets";
import { Modal } from "@/components";
import {
  CALCULATE_BY_BLOCK_4_6_8,
  countDecimals,
  CREATE_TYPE,
  DATE_FORMAT_V2,
  DATE_FORMAT_V2_FULL,
  EDIT_TYPE,
  filterOption,
  formatStringToDate,
  getInfoStaffFull,
  handleMessagesAPI,
  isInteger,
  isNumeric,
  isValidHttpUrl,
  OT_TYPES,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
  POLICY_MANAGEMENT_EMPLOYEE_SCREEN,
  REMOVE_TYPE,
  toFixedNumber,
} from "@/utils";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "PolicyManagementEmployeeModal",
  components: {
    Modal,
  },
  emits: ["onCancel", "fetchData"],
  props: {
    visibleModal: {
      type: Boolean,
      require: true,
    },
    data: {
      type: Object,
    },
    type: {
      type: String,
    },
    fromPage: {
      type: String,
    },
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
      },
      formRQ: this.$form.createForm(this, { name: "formLeaveCarryover", onValuesChange: this.onValuesChange }),
      formData: {},
      DATE_FORMAT_V2,
      fetching: false,
      timeout: null,
      loading: false,
      InfoBold,
      remainAnnualLeave: null,
      CREATE_TYPE,
      disabledFieldEdit: false,
      REMOVE_TYPE,
      POLICY_MANAGEMENT_EMPLOYEE_SCREEN,
      OT_TYPES,
      loadingUser: false,
    };
  },
  watch: {
    computeProps() {
      if (this.visibleModal) {
        this.handleInitFormData();
      }
    },
  },
  computed: {
    ...mapState({
      employeeList: (state) => state.filters.employeeList,
      financialYearList: (state) => state.advance.financialYearList,
      remainAnnualLeaveByFinancialAndEmployee: (state) => state.filters.remainAnnualLeaveByFinancialAndEmployee,
      timeServer: (state) => state.application.timeServer,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
      workScheduleCodeList: (state) => state.filters.workScheduleCodeList,
      workScheduleTypeList: (state) => state.filters.workScheduleTypeList,
      policyManagementEmployeeHistoryInfo: (state) =>
        state.policyManagementEmployee.policyManagementEmployeeHistoryInfo,
      selectedRowKeys: (state) => state.application.selectedRowKeys,
      workRuleWorkScheduleConfigList: (state) => state.filters.workRuleWorkScheduleConfigList,
    }),
    generateTitle() {
      switch (this.type) {
        case CREATE_TYPE:
          return "Set Staff Policy";
        case EDIT_TYPE:
          return "Edit Staff Policy";
        case REMOVE_TYPE:
          return "Please Confirm";
        default:
          return "Set Staff Policy";
      }
    },
    workScheduleTypeListFilter() {
      const { workScheduleTypeList } = this;
      return workScheduleTypeList?.filter((type) => type.code !== CALCULATE_BY_BLOCK_4_6_8);
    },
    computeProps() {
      const { type, formPage, data } = this;
      return { type, formPage, data };
    },
  },
  async created() {
    // Get recent timesheet approved
    this.$store.dispatch("advance/getMostRecentTimeSheetApproved");
    // Get work schedule code
    // this.$store.dispatch("filters/getWorkScheduleCodeList");
    // Get work schedule type
    this.$store.dispatch("filters/getWorkScheduleTypeList");
    // Get work schedule config list
    this.$store.dispatch("filters/getRuleWorkScheduleConfigList");

    // Handle initial form
    this.handleInitFormData();
  },

  methods: {
    filterOption,
    validateHttpUrl(rule, value, callback) {
      if (value) {
        if (!isValidHttpUrl(value)) {
          callback("Http Link is invalid");
        }
      }
      callback();
    },
    validateNumber(rule, value, callback, title, integer) {
      if (value) {
        if (!isNumeric(value)) {
          callback(`${title} is invalid`);
        }
        if (integer) {
          if (!isInteger(value)) {
            callback(`${title} is integer`);
          }
        }
        if (Number(value) < 0 || Number(value) >= 200) {
          callback(`${title} must be between 0 and ${200}`);
        }
        if (countDecimals(Number(value)) >= 2) {
          callback("Invalid duration (ex: 0.1, 0.2, 1, 1.1, ...) ");
        }
      }
      callback();
    },
    handleInitFormData() {
      const { type, data, policyManagementEmployeeHistoryInfo, fromPage, workRuleWorkScheduleConfigList } = this;
      if (type === EDIT_TYPE) {
        if (!data) return;
        const {
          fullName,
          work_schedule_code,
          rule_type,
          refund_hours_per_explanation,
          explanation_time_per_days,
          explanation_number,
          ot_type,
          url_policy,
          apply_date,
          expire_date,
        } = data;
        if (!workRuleWorkScheduleConfigList || workRuleWorkScheduleConfigList?.length <= 0) return;
        const findRuleWorkScheduleConfig = workRuleWorkScheduleConfigList.find(
          (rule) => rule?.work_schedule_code === work_schedule_code
        );
        this.formData = {
          ...this.formData,
          staff: fullName,
          work_schedule_code,
          rule_type,
          refund_hours_per_explanation,
          explanation_time_per_days,
          explanation_number,
          ot_type,
          url_policy,
          apply_date: formatStringToDate(apply_date, DATE_FORMAT_V2),
          expire_date: formatStringToDate(expire_date, DATE_FORMAT_V2),
          lack_of_time_allowed: findRuleWorkScheduleConfig.lack_of_time_allowed ?? 0
        };
        if (
          moment(apply_date, DATE_FORMAT_V2_FULL).isSameOrBefore(
            moment(this.mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL)
          )
        ) {
          this.disabledFieldEdit = true;
        }
      } else if (type === CREATE_TYPE && fromPage === POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN) {
        this.formData = {
          ...this.formData,
          staff: getInfoStaffFull(policyManagementEmployeeHistoryInfo),
        };
      } else {
        const { selectedRowKeys } = this;
        if (selectedRowKeys?.length > 0) {
          this.loadingUser = true;
          const uniqueUsernames = [...new Set(selectedRowKeys)];
          const textSearch = uniqueUsernames.join(",");
          this.formData = { ...this.formData, usernames: uniqueUsernames };
          this.$store.dispatch("filters/getEmployeeList", textSearch).finally(() => {
            this.loadingUser = false;
          });
        }
      }
    },
    onSearchStaff(textSearch, timeout = 1000) {
      if (!textSearch || !textSearch?.trim() || textSearch.trim().length <= 2) return;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.fetching = true;
      this.timeout = setTimeout(async () => {
        try {
          await this.$store.dispatch("filters/getEmployeeList", textSearch);
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.fetching = false;
        }
      }, timeout);
    },
    handleDisabledApplyDate(date) {
      const { mostRecentTimeSheetApproved } = this;
      const expireDate = this.formRQ.getFieldValue("expire_date");

      return (
        (expireDate && moment(date).startOf("day").isAfter(moment(expireDate).startOf("day"))) ||
        moment(date).isBefore(moment(mostRecentTimeSheetApproved, DATE_FORMAT_V2_FULL).add(1, "days"))
      );
    },
    handleDisabledExpireDate(date) {
      const applyDate = this.formRQ.getFieldValue("apply_date");
      return (
        (applyDate && moment(date).isBefore(moment(applyDate))) ||
        moment(date).startOf("day").isBefore(moment(this.timeServer, DATE_FORMAT_V2_FULL).startOf("day"))
      );
    },
    handleChangeWorkScheduleCode(value) {
      const { workRuleWorkScheduleConfigList } = this;
      if (!workRuleWorkScheduleConfigList || workRuleWorkScheduleConfigList?.length <= 0) return;
      const findRuleWorkScheduleConfig = workRuleWorkScheduleConfigList.find(
        (rule) => rule?.work_schedule_code === value
      );
      if (findRuleWorkScheduleConfig) {
        const {
          explanation_number,
          explanation_time_per_days,
          refund_hours_per_explanation,
          ot_type,
          url_policy,
          rule_type,
          lack_of_time_allowed
        } = findRuleWorkScheduleConfig;
        this.formRQ.setFieldsValue({
          explanation_number: explanation_number ?? 0,
          explanation_time_per_days: explanation_time_per_days ?? 0,
          refund_hours_per_explanation: refund_hours_per_explanation ?? 0,
          ot_type,
          url_policy,
          rule_type,
          lack_of_time_allowed: lack_of_time_allowed ?? 0
        });
      }
    },
    onCancel() {
      this.formData = {};
      this.formRQ.resetFields();
      this.$emit("onCancel");
      this.disabledFieldEdit = false;
    },
    onOk() {
      this.formRQ.validateFields(async (error, values) => {
        if (error) return;
        const { fromPage, policyManagementEmployeeHistoryInfo, type, data } = this;
        let {
          apply_date,
          expire_date,
          explanation_number,
          refund_hours_per_explanation,
          explanation_time_per_days,
          ...payload
        } = values;
        payload.apply_date = apply_date ? moment(apply_date).startOf("day").format(DATE_FORMAT_V2_FULL) : null;
        payload.expire_date = expire_date ? moment(expire_date).startOf("day").format(DATE_FORMAT_V2_FULL) : null;
        payload = {
          ...payload,
          apply_date: apply_date ? moment(apply_date).startOf("day").format(DATE_FORMAT_V2_FULL) : null,
          expire_date: expire_date ? moment(expire_date).startOf("day").format(DATE_FORMAT_V2_FULL) : null,
          explanation_number: toFixedNumber(explanation_number, 1),
          refund_hours_per_explanation: toFixedNumber(refund_hours_per_explanation, 1),
          explanation_time_per_days: toFixedNumber(explanation_time_per_days, 1),
        };
        if (fromPage === POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN) {
          payload.usernames = [policyManagementEmployeeHistoryInfo?.user_name];
        }
        this.loading = true;
        let result = {};
        try {
          if (type === CREATE_TYPE) {
            result = await this.$store.dispatch("policyManagementEmployee/createPolicyManagementEmployee", payload);
          } else if (type === EDIT_TYPE) {
            result = await this.$store.dispatch("policyManagementEmployee/editPolicyManagementEmployee", {
              id: data?.id,
              ...payload,
            });
          } else {
            result = await this.$store.dispatch("policyManagementEmployee/deletePolicyManagementEmployee", {
              id: data?.id,
            });
          }
          const { code } = result;
          handleMessagesAPI(result);
          if (code == 200) {
            this.onCancel();
            this.$emit("fetchData");
          }
        } catch (error) {
          handleMessagesAPI(error.response.data);
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
